export default theme => ({
  root: {
    ...theme.flexColumnCenter,
    justifyContent: 'flex-start',
    flexGrow: 1,
    height: '100%',
    width: '100%',
    margin: '.2rem',
    fontSize: '1.4rem'
  },
  submit: {
    ...theme.flexColumnCenter,
    justifyContent: 'center',
    textAlign: 'center',
    minWidth: '280px',
    marginTop: '2.8rem',
    borderRadius: '50'
  },
  submitButton: {
    ...theme.flexColumnCenter,
    width: '100%',
    borderRadius: 50
  },
  inputField: {
    width: 280,
    marginTop: 10
  },
  inputIcon: {
    position: 'absolute',
    left: '-30px',
    top: '31px'
  },
  inputContainer: {
    position: 'relative'
  },
  inputAdornment: {
    marginRight: '18px',
    position: 'relative'
  }
});
